{
    "wixui.skins.SelectionTagsList": {
        "params": {
            "desktopVerticalPadding": {
                "hide": true
            },
            "desktopHorizontalPadding": {
                "hide": true
            },
            "desktopVerticalMargin": {
                "hide": true
            },
            "desktopHorizontalMargin": {
                "hide": true
            },
            "mobileVerticalPadding": {
                "hide": true
            },
            "mobileHorizontalPadding": {
                "hide": true
            },
            "mobileVerticalMargin": {
                "hide": true
            },
            "mobileHorizontalMargin": {
                "hide": true
            },
            "brw": {
                "state": "regular",
                "category": "border",
                "label": "CustomDesign_Borders_Width",
                "max": 15
            },
            "brd_s": {
                "state": "selected",
                "category": "border",
                "label": "CustomDesign_Borders_Color&Opacity"
            },
            "fnt": {
                "section": "tag"
            },
            "txt_s": {
                "state": "selected",
                "category": "text",
                "label": "CustomDesign_Text_TextColor",
                "section": "tag"
            },
            "bg_s": {
                "state": "selected",
                "category": "fill",
                "label": "CustomDesign_FillColor_BGColor&Opacity"
            },
            "brd_d": {
                "state": "disabled",
                "category": "border",
                "label": "CustomDesign_Borders_Color&Opacity"
            },
            "txt_d": {
                "state": "disabled",
                "category": "text",
                "label": "CustomDesign_Text_TextColor",
                "section": "tag"
            },
            "bg_d": {
                "state": "disabled",
                "category": "fill",
                "label": "CustomDesign_FillColor_BGColor&Opacity"
            },
            "brd_e": {
                "state": "error",
                "category": "border",
                "label": "CustomDesign_Borders_Color&Opacity"
            },
            "txt_e": {
                "state": "error",
                "category": "text",
                "label": "CustomDesign_Text_TextColor",
                "section": "tag"
            },
            "bg_e": {
                "state": "error",
                "category": "fill",
                "label": "CustomDesign_FillColor_BGColor&Opacity"
            },
            "brd_h": {
                "state": "hover",
                "category": "border",
                "label": "CustomDesign_Borders_Color&Opacity"
            },
            "txt_h": {
                "state": "hover",
                "category": "text",
                "label": "CustomDesign_Text_TextColor",
                "section": "tag"
            },
            "bg_h": {
                "state": "hover",
                "category": "fill",
                "label": "CustomDesign_FillColor_BGColor&Opacity"
            }
        },
        "sections": {
            "tag": {
                "label": "CustomDesign_Tag_Section",
                "priority": 2
            }
        }
    },
    "wixui.skins.RichTextBox": {
        "params": {
            "txt": {
                "category": "text",
                "label": "CustomDesign_Text_TextColor",
                "priority": "1",
                "section": "input"
            },
            "txtd": {
                "state": "disabled",
                "priority": "1",
                "section": "input"
            },
            "placeHolderTextColor": {
                "label": "CustomDesign_InputControls_Placeholder_Text_Color",
                "priority": "2",
                "section": "input"
            },
            "linkColor": {
                "label": "CustomDesign_Text_LinkColor",
                "priority": "3",
                "section": "input"
            },
            "fnt": {
                "priority": "4",
                "section": "input"
            }
        },
        "sections": {
            "input": {
                "label": "CustomDesign_Input_Section",
                "priority": 2
            }
        }
    },
    "wixui.skins.Slider": {
        "params": {
            "tooltipFontColor": {
                "state": "regular",
                "category": "text",
                "section": "tooltipText",
                "priority": "3"
            },
            "tooltipFontFamily": {
                "state": "regular",
                "category": "text",
                "section": "tooltipText",
                "priority": "3"
            },
            "tooltipFontSize": {
                "state": "regular",
                "category": "text",
                "section": "tooltipText",
                "priority": "3",
                "min": 10,
                "max": 24
            }
        },
        "sections": {
            "tooltipText": {
                "label": "CustomDesign_Tooltip_Section",
                "priority": 2
            }
        }
    },
    "wixui.skins.ToggleSwitch": {
        "params": {
            "fntlbl": {
                "compPart": "on"
            },
            "txtlbl": {
                "compPart": "on"
            }
        },
        "sections": {
            "track": {
                "label": "CustomDesign_ToggleSwitch_Track",
                "priority": 2
            },
            "knob": {
                "label": "CustomDesign_ToggleSwitch_Knob",
                "priority": 3
            }
        }
    },
    "wixui.skins.Rating": {
        "params": {
            "labelFontColor": {
                "priority": "1",
                "section": "rating"
            },
            "labelFont": {
                "max": 100,
                "min": 6,
                "priority": "2",
                "section": "rating"
            },
            "errorLabelFontColor": {
                "priority": "1",
                "section": "rating"
            }
        },
        "sections": {
            "rating": {
                "label": "CustomDesign_Hover_Text_Section",
                "priority": 2
            }
        }
    },
    "wixui.skins.SignatureInput": {
        "params": {
            "padBackground": {
                "state": "regular",
                "category": "fill",
                "priority": "1",
                "section": "background",
                "label": "CustomDesign_FillColor_BGColor&Opacity"
            },
            "padBackgroundHover": {
                "state": "hover",
                "category": "fill",
                "priority": "1",
                "section": "background",
                "label": "CustomDesign_FillColor_BGColor&Opacity"
            },
            "padBackgroundFocus": {
                "state": "focus",
                "category": "fill",
                "priority": "1",
                "section": "background",
                "label": "CustomDesign_FillColor_BGColor&Opacity"
            },
            "padBackgroundError": {
                "state": "error",
                "category": "fill",
                "priority": "1",
                "section": "background",
                "label": "CustomDesign_FillColor_BGColor&Opacity"
            },
            "padBackgroundDisabled": {
                "state": "disabled",
                "category": "fill",
                "priority": "1",
                "section": "background",
                "label": "CustomDesign_SignatureInput_Background_BGColor"
            },
            "padLineColor": {
                "state": "regular",
                "category": "fill",
                "priority": "1",
                "label": "CustomDesign_Borders_Color&opacity",
                "section": "signatureLine"
            },
            "padLineColorHover": {
                "state": "hover",
                "category": "fill",
                "priority": "1",
                "label": "CustomDesign_Borders_Color&opacity",
                "section": "signatureLine"
            },
            "padLineColorFocus": {
                "state": "focus",
                "category": "fill",
                "priority": "1",
                "label": "CustomDesign_Borders_Color&opacity",
                "section": "signatureLine"
            },
            "padLineColorError": {
                "state": "error",
                "category": "fill",
                "priority": "1",
                "label": "CustomDesign_Borders_Color&opacity",
                "section": "signatureLine"
            },
            "padLineColorDisabled": {
                "state": "disabled",
                "category": "fill",
                "priority": "1",
                "label": "CustomDesign_Borders_Color&opacity",
                "section": "signatureLine"
            },
            "padLineWidth": {
                "state": "regular",
                "category": "fill",
                "priority": "2",
                "label": "CustomDesign_Borders_Width",
                "section": "signatureLine"
            },
            "padLineWidthHover": {
                "state": "hover",
                "category": "fill",
                "priority": "2",
                "label": "CustomDesign_Borders_Width",
                "section": "signatureLine"
            },
            "padLineWidthFocus": {
                "state": "focus",
                "category": "fill",
                "priority": "2",
                "label": "CustomDesign_Borders_Width",
                "section": "signatureLine"
            },
            "padLineWidthError": {
                "state": "error",
                "category": "fill",
                "priority": "2",
                "label": "CustomDesign_Borders_Width",
                "section": "signatureLine"
            },
            "padLineWidthDisabled": {
                "state": "disabled",
                "category": "fill",
                "priority": "2",
                "label": "CustomDesign_Borders_Width",
                "section": "signatureLine"
            },
            "signatureColor": {
                "state": "regular",
                "category": "fill",
                "priority": "1",
                "label": "CustomDesign_SignatureInput_Signature_Color",
                "section": "signatureInput"
            },
            "signatureSize": {
                "state": "regular",
                "category": "fill",
                "priority": "2",
                "label": "CustomDesign_Borders_Width",
                "section": "signatureInput",
                "min": 1,
                "max": 4
            },
            "padBorderColor": {
                "state": "regular",
                "category": "border",
                "priority": "1",
                "label": "CustomDesign_Border_Opacity&Color"
            },
            "padBorderColorHover": {
                "state": "hover",
                "category": "border",
                "priority": "1",
                "label": "CustomDesign_Border_Opacity&Color"
            },
            "padBorderColorFocus": {
                "state": "focus",
                "category": "border",
                "priority": "1",
                "label": "CustomDesign_Border_Opacity&Color"
            },
            "padBorderColorError": {
                "state": "error",
                "category": "border",
                "priority": "1",
                "label": "CustomDesign_Border_Opacity&Color"
            },
            "padBorderColorDisabled": {
                "state": "disabled",
                "category": "border",
                "priority": "1",
                "label": "CustomDesign_Border_Opacity&Color"
            },
            "padBorderWidth": {
                "state": "regular",
                "category": "border",
                "priority": "2",
                "label": "CustomDesign_Borders_Width"
            },
            "padBorderWidthHover": {
                "state": "hover",
                "category": "border",
                "priority": "2",
                "label": "CustomDesign_Borders_Width"
            },
            "padBorderWidthFocus": {
                "state": "focus",
                "category": "border",
                "priority": "2",
                "label": "CustomDesign_Borders_Width"
            },
            "padBorderWidthError": {
                "state": "error",
                "category": "border",
                "priority": "2",
                "label": "CustomDesign_Borders_Width"
            },
            "padBorderWidthDisabled": {
                "state": "disabled",
                "category": "border",
                "priority": "2",
                "label": "CustomDesign_Borders_Width"
            },
            "padBorderRadius": {
                "state": "regular",
                "category": "corners",
                "priority": "1"
            },
            "padBoxShadow": {
                "state": "regular",
                "category": "shadow",
                "priority": "1"
            },
            "titleColor": {
                "state": "regular",
                "category": "text",
                "priority": "1",
                "label": "CustomDesign_SignatureInput_Title_Color",
                "section": "fieldTitle"
            },
            "titleColorDisabled": {
                "state": "disabled",
                "category": "text",
                "priority": "1",
                "label": "CustomDesign_SignatureInput_Title_Color",
                "section": "fieldTitle"
            },
            "titleAsteriskColor": {
                "state": "regular",
                "category": "text",
                "priority": "2",
                "label": "CustomDesign_SignatureInput_Required_Asterisk_Color",
                "section": "fieldTitle"
            },
            "titleAsteriskColorDisabled": {
                "state": "disabled",
                "category": "text",
                "priority": "2",
                "label": "CustomDesign_SignatureInput_Required_Asterisk_Color",
                "section": "fieldTitle"
            },
            "titleFont": {
                "state": "regular",
                "category": "text",
                "priority": "3",
                "section": "fieldTitle"
            },
            "titleFontDisabled": {
                "state": "disabled",
                "category": "text",
                "priority": "3",
                "section": "fieldTitle"
            },
            "clearButtonColor": {
                "state": "regular",
                "category": "text",
                "priority": "1",
                "label": "CustomDesign_SignatureInput_Clear_Button_Color",
                "section": "clearButton"
            },
            "clearButtonColorFocus": {
                "state": "focus",
                "category": "text",
                "priority": "1",
                "label": "CustomDesign_SignatureInput_Clear_Button_Color",
                "section": "clearButton"
            },
            "clearButtonColorDisabled": {
                "state": "disabled",
                "category": "text",
                "priority": "1",
                "label": "CustomDesign_SignatureInput_Clear_Button_Color",
                "section": "clearButton"
            },
            "clearButtonFont": {
                "state": "regular",
                "category": "text",
                "priority": "2",
                "section": "clearButton"
            },
            "clearButtonFontDisabled": {
                "state": "disabled",
                "category": "text",
                "priority": "2",
                "section": "clearButton"
            }
        },
        "sections": {
            "background": {
                "label": "CustomDesign_Fill_SignatureInput_Background_Section_Title",
                "priority": 1
            },
            "signatureLine": {
                "label": "CustomDesign_Fill_SignatureInput_Signature_Line_Section_Title",
                "priority": 2
            },
            "signatureInput": {
                "label": "CustomDesign_Fill_SignatureInput_Signature_Input_Section_Title",
                "priority": 3
            },
            "fieldTitle": {
                "label": "CustomDesign_Text_SignatureInput_Field_Title_Section_Title",
                "priority": 1
            },
            "clearButton": {
                "label": "CustomDesign_Text_SignatureInput_Clear_Button_Section_Title",
                "priority": 2
            }
        }
    },
    "wixui.skins.MusicPlayer": {
        "params": {
            "backgroundColorIcon": {
                "hide": true
            },
            "regularColorIcon": {
                "hide": true
            }
        }
    },
    "wixui.skins.VideoPlayer": {
        "params": {
            "coverImage": {
                "state": "regular",
                "category": "cover_image",
                "priority": 1
            }
        },
        "sections": {
            "coverImage": {
                "label": "Custom.design_video.player_cover.Image_tab_title",
                "priority": 1
            }
        }
    },
    "wixui.skins.ImageX": {
        "sections": {
            "colors": {
                "label": "some-section-label-translation-key"
            }
        },
        "params": {
            "color": {
                "label": "some-label-translation-key",
                "section": "colors"
            },
            "borderColor": {
                "category": "border",
                "defaultValue": "color_8",
                "state": "regular",
                "type": "COLOR_ALPHA",
                "label": "CustomDesign_Borders_Color&Opacity"
            },
            "blendMode": {
                "category": "fill",
                "defaultValue": "normal",
                "state": "regular",
                "type": "BLEND_MODE",
                "label": "CustomDesign_BlendMode"
            }
        }
    }
}
